export const hush = null;
export var PurchaseOption;
(function (PurchaseOption) {
    PurchaseOption["NONE"] = "NONE";
    PurchaseOption["BUY_NOW"] = "BUY_NOW";
    PurchaseOption["CONTACT_SALES"] = "CONTACT_SALES";
})(PurchaseOption || (PurchaseOption = {}));
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["NONE"] = "NONE";
    SubscriptionType["FREE_TRIAL"] = "FREE_TRIAL";
    SubscriptionType["TEAMS_EDITION"] = "TEAMS_EDITION";
    SubscriptionType["DEVELOPER_EDITION"] = "DEVELOPER_EDITION";
    SubscriptionType["ESSENTIALS_EDITION"] = "ESSENTIALS_EDITION";
})(SubscriptionType || (SubscriptionType = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["PAST_DUE"] = "PAST_DUE";
    SubscriptionStatus["UNPAID"] = "UNPAID";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["INCOMPLETE"] = "INCOMPLETE";
    SubscriptionStatus["INCOMPLETE_EXPIRED"] = "INCOMPLETE_EXPIRED";
    SubscriptionStatus["TRIALING"] = "TRAILING";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var CLUSTER_TYPES;
(function (CLUSTER_TYPES) {
    CLUSTER_TYPES["PROD"] = "PROD";
    CLUSTER_TYPES["DEV"] = "DEV";
    CLUSTER_TYPES["STAGING"] = "STAGING";
})(CLUSTER_TYPES || (CLUSTER_TYPES = {}));
export var UserPersona;
(function (UserPersona) {
    UserPersona["ANALYST"] = "analyst";
    UserPersona["BUSINESS_USER"] = "business_user";
    UserPersona["BUSINESS_PERSONA"] = "business_persona";
    UserPersona["ANALYST_PERSONA"] = "analyst_persona";
    UserPersona["DEVELOPER_PERSONA"] = "developer_persona";
    UserPersona["UNDEFINED"] = "";
})(UserPersona || (UserPersona = {}));
export var UserActivationMode;
(function (UserActivationMode) {
    UserActivationMode["SAAS_FREE_TRIAL"] = "saas_free_trial";
    UserActivationMode["SAAS_PRODUCTION"] = "saas_production";
    UserActivationMode["PARTNER_CONNECT"] = "partner_connect";
})(UserActivationMode || (UserActivationMode = {}));
export var InviteModalType;
(function (InviteModalType) {
    InviteModalType["DEFAULT"] = "DEFAULT";
    InviteModalType["EMAIL_REFERRAL"] = "EMAIL_REFERRAL";
})(InviteModalType || (InviteModalType = {}));
export var DataBaseMode;
(function (DataBaseMode) {
    DataBaseMode["EMBRACE"] = "EMBRACE";
    DataBaseMode["MIXED"] = "MIXED";
    DataBaseMode["FALCON"] = "FALCON";
})(DataBaseMode || (DataBaseMode = {}));
export var CsvUploadMode;
(function (CsvUploadMode) {
    CsvUploadMode["EMBRACE"] = "EMBRACE";
    CsvUploadMode["FALCON"] = "FALCON";
})(CsvUploadMode || (CsvUploadMode = {}));
export var PasswordStrategy;
(function (PasswordStrategy) {
    PasswordStrategy["GUESS_ESTIMATE"] = "GUESS_ESTIMATE";
    PasswordStrategy["COMPLEXITY"] = "COMPLEXITY";
})(PasswordStrategy || (PasswordStrategy = {}));
export var UserState;
(function (UserState) {
    UserState["ACTIVE"] = "ACTIVE";
    UserState["INACTIVE"] = "INACTIVE";
    UserState["EXPIRED"] = "EXPIRED";
    UserState["LOCKED"] = "LOCKED";
    UserState["PENDING"] = "PENDING";
})(UserState || (UserState = {}));
export const DEFAULT_PRODUCT_NAME = 'DEFAULT_PRODUCT_NAME';
export var ListCategory;
(function (ListCategory) {
    ListCategory["All"] = "ALL";
    ListCategory["My"] = "MY";
    ListCategory["Favorite"] = "FAVORITE";
    ListCategory["NonFavorite"] = "NON_FAVORITE";
    ListCategory["Requested"] = "REQUESTED";
})(ListCategory || (ListCategory = {}));
//# sourceMappingURL=session-interface.js.map